
import Vue from "vue";
import { getModule } from "vuex-module-decorators";
import StockOrderModule from "@/store/modules/barcodeSystem/stockOrder";
import { StockOrderListItem } from "@/models/api/barcodeSystem/stockOrders/get";

const stockOrderModuleState = getModule(StockOrderModule);

import draggable from "vuedraggable";

import RightClickMenu from "@/components/widgets/RightClickMenu.vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component({
  components: {
    RightClickMenu,
    draggable
  }
})
export default class BarcodeOrderTable extends Vue {
  @Prop({ default: "table" })
  public id: string;

  @Prop({ default: "" })
  public containerClass: string;

  @Prop({ default: null })
  public tableField: Array<any>;

  @Prop({ default: null })
  public tableMenuItem: Array<any>;

  public rightClickLocation: any = null;
  public showHelp: boolean = false;
  public draggingData: boolean = false;

  get filterFields() {
    let filterFields = this.tableField.filter(
      field => field.hidden === false && field.key !== "selected"
    );
    return filterFields;
  }

  set filterFields(newValue) {
    this.$emit("updateFields", newValue);
  }

  get orders(): Array<StockOrderListItem> {
    return stockOrderModuleState.data;
  }

  get loading(): boolean {
    return stockOrderModuleState.loading;
  }

  get selectedItemCount(): number {
    return stockOrderModuleState.getSelectedItemCount;
  }

  get selectedItems(): Array<any> {
    return stockOrderModuleState.getSelectedItems;
  }

  
  get totalItems() {
    if (stockOrderModuleState.pageData) {
      const items = stockOrderModuleState.pageData.totalItems;
      return items ? items : 0;
    } else {
      return 0;
    }
  }

  
  get currentSortAscending() {
    return stockOrderModuleState.dataSortAscending;
  }
  get currentSort() {
    return stockOrderModuleState.dataSortKey;
  }

  unselectAll() {
    let items = this.selectedItems;

    items.forEach(summary => {
      stockOrderModuleState.switchSelectionStatus(summary.id);
    });
  }

  getComponentData(rowData) {
    return {
      on: {
        click: () => this.onRowClick(rowData),
        contextmenu: $event => this.onRightClicked(rowData, $event),
        dblclick: () => this.onDoubleClicked(rowData)
      }
    };
  }
  canMove() {
    return false;
  }
  putFeature() {
    return false;
  }
  sort(s) {
    this.$emit("sort", s);
  }

  onRightClicked(rowData, event) {
    event.preventDefault();
    if (!rowData.selected) stockOrderModuleState.switchSelectionStatus(rowData.id);

    this.rightClickLocation = { x: event.x, y: event.y };
  }

  onDoubleClicked(data) {
    stockOrderModuleState.viewStockOrderShortcutAction( {selectedItems: [data]});
  }

  onRowClick(rowData) {
    stockOrderModuleState.switchSelectionStatus(rowData.id);

    this.clearRightClick();
  }
  clearRightClick() {
    this.rightClickLocation = null;
    this.draggingData = false;
  }
  clickMenu(item) {
    let items = this.selectedItems;
    this.$store.dispatch(item.action, { selectedItems: items });
    this.clearRightClick();
  }
  onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
    if (
      Math.ceil(scrollTop) + 1 + clientHeight >= scrollHeight &&
      !this.loading &&
      stockOrderModuleState.pageData.totalItems > this.orders.length
    ) {
      this.$emit("loadMoreData");
    }
  }

  getFieldClass(field, data) {
    var fieldClass = null;
    if (field.textAlign) {
      switch (field.textAlign) {
        case "right":
          fieldClass = "text-right";
          break;
        case "left":
          fieldClass = "text-left";
          break;
        case "center":
          fieldClass = "text-center";
          break;
        default:
          break;
      }
    }

    if(field.noWrap)
    {
      fieldClass += " text-nowrap";
    }

    return fieldClass;
  }
  
  getValue(object, path) {
    if (!path) return;
    return path.split(".").reduce((r, k) => (r ? r[k] : ""), object);
  }
}
